
import Vue from 'vue';
import organizationApi from "@/services/api.organizationSettings.ts";
import { Getter } from "vuex-class";
import Component from "vue-class-component";
import EventOutcomeSelect from "@/components/form/EventOutcomeSelect.vue";
import { FeaturesList } from "@/store/types";
import vSelect3 from "vselect3";
import { HealthCheckSetting, HealthCheckType, HealthCheckTypeIds, HealthCheckTypeLabels } from '@/types/sv-data/OrganizationSettings';

@Component({
	components:{
		"event-outcome-select": EventOutcomeSelect,
		"v-select-3": vSelect3,
	}
})

export default class HealthCheckSettings extends Vue {
	private healthCheckPrefs: HealthCheckSetting | null = null;

	private healthCheckSettings: HealthCheckSetting = {
		healthCheckType: 0,
        setCameraByDefault: false
	};

    private healthCheckTypeOptions: HealthCheckType[] = [
        {
            id: HealthCheckTypeIds.EnabledOnly,
            label: HealthCheckTypeLabels.EnabledOnly
        },
        {
            id: HealthCheckTypeIds.AllServers,
            label: HealthCheckTypeLabels.AllServers
        }
    ]

	private newHealthCheckType: number = 0;
    private newSetCameraByDefault: boolean = false;

	private async beforeMount(): Promise<void> {
		try {
			this.healthCheckPrefs = await organizationApi.retrieveHealthCheckPrefs();
		} catch (e) {
			console.log("Failed to get tenant system prefs");
		}

		if (!this.healthCheckPrefs) {
			this.newHealthCheckType = HealthCheckTypeIds.EnabledOnly;
			this.newSetCameraByDefault = false;
			return;
		}

		this.healthCheckSettings.healthCheckType = this.healthCheckPrefs?.healthCheckType ?? HealthCheckTypeIds.EnabledOnly;
        this.healthCheckSettings.setCameraByDefault = this.healthCheckPrefs?.setCameraByDefault ?? false;

		this.newHealthCheckType = this.healthCheckPrefs?.healthCheckType ?? HealthCheckTypeIds.EnabledOnly;
        this.newSetCameraByDefault = this.healthCheckPrefs?.setCameraByDefault ?? false;
}

	private get haveSettingsChanged(): boolean {
		return this.healthCheckPrefs?.healthCheckType !== this.newHealthCheckType 
            || this.healthCheckPrefs?.setCameraByDefault !== this.newSetCameraByDefault;
	}

	private async resetChanges(): Promise<void> {
		this.newHealthCheckType = this.healthCheckPrefs?.healthCheckType ?? HealthCheckTypeIds.EnabledOnly;
        this.newSetCameraByDefault = this.healthCheckPrefs?.setCameraByDefault ?? false;
	}

	private async confirmUpdateHealthCheck(): Promise<void> {
		const newTenantSettings: HealthCheckSetting = {
			healthCheckType: this.newHealthCheckType,
            setCameraByDefault: this.newSetCameraByDefault
		};

		try {
			await organizationApi.createOrUpdateHealthCheckPrefs(newTenantSettings);
		} catch (e) {
			console.error("Error updating health check settings", e);
            this.$notify({
                type: "error",
                title: "Failed to update health check settings"
            });
            return;
		}

		this.healthCheckSettings.healthCheckType = newTenantSettings.healthCheckType;
        this.healthCheckSettings.setCameraByDefault = newTenantSettings.setCameraByDefault;
		this.healthCheckPrefs = newTenantSettings;

		this.$notify({
			type: "success",
			title: "Health check settings updated"
		});
	}

	private get UpdateButtonDisabled(): boolean {
		return !this.haveSettingsChanged
	}
}
